import { Selector } from '@hub/shared'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './extra-requirements.component.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  suggestionRequirements?: string[]
  onChange?: (value: any) => any
}

export default ({ suggestionRequirements, onChange, ...props }: Props) => {
  const [t] = useTranslation('extraRequirements')
  const [state, setState] = useState<object>(null)

  useEffect(() => {
    if (suggestionRequirements?.length > 0) {
      for (const aux of suggestionRequirements) {
        setState((prevState) => ({ ...prevState, [aux]: false }))
      }
    }
  }, [suggestionRequirements])

  useEffect(() => {
    if (state && onChange && typeof onChange === 'function' && suggestionRequirements?.length > 0) {
      onChange(Object.values(state).every((fieldValue) => fieldValue))
    }
  }, [state, onChange, suggestionRequirements])

  const handleChange = useCallback(
    (field: string, value: boolean) => {
      setState({ ...state, [field]: value })
    },
    [state]
  )

  if (suggestionRequirements?.length < 1) {
    return null
  }

  return (
    <section className="extra-requirements" {...props}>
      <div className="title">
        <h5>{t('title')}</h5>
        <p>{t('subTitle')}:</p>
      </div>
      {suggestionRequirements?.map((requirement: any, index) => (
        <Selector
          name="extra-requirements-selector"
          id={`extra-requirements-selector-${index}`}
          key={`extra-${index}`}
          checked={state?.[requirement]}
          onChange={() => handleChange(requirement, !state[requirement])}
          type="checkbox"
          errorSpan={false}
          rightLabel={requirement}
          boxBgSecondary
        />
      ))}
    </section>
  )
}
